const formattedMessage = {}
export default formattedMessage

export const captions = {
  RULE_NAME: {
    id: 't.app.settings.processingRules.form.ruleNameLabel',
    defaultMessage: 'Rule Name"'
  },
  RULE_TYPE: {
    id: 't.app.settings.processingRules.form.ruleTypeLabel',
    defaultMessage: 'Rule Type'
  },
  STATUS: {
    id: 't.app.settings.processingRules.form.statusLabel',
    defaultMessage: 'Status'
  },
  RULE_TYPE_ariaLabel: {
    id: 't.app.accessibility.settings.processingRules.form.ruleTypeLabel.ariaLabel',
    defaultMessage: 'Rule Type'
  },
  STATUS_ariaLabel: {
    id: 't.app.accessibility.settings.processingRules.form.statusLabel.ariaLabel',
    defaultMessage: 'Status'
  },
  CARD_BIN_BLOCK: {
    id: 't.app.settings.processingRules.form.cardBinBlockLabel',
    defaultMessage: 'Card Bin Block'
  },
  SINGLE_PAN_BLOCK: {
    id: 't.app.settings.processingRules.form.singlePanBlockLabel',
    defaultMessage: 'Single Pan Block'
  },
  MASKED_PAN: {
    id: 't.app.settings.processingRules.form.maskedPanLabel',
    defaultMessage: 'Masked Pan'
  },
  CARD_TYPE: {
    id: 't.app.accessibility.settings.processingRules.form.cardTypeLabel.ariaLabel',
    defaultMessage: 'Card Type'
  },
  IP_BLOCK: {
    id: 't.app.settings.processingRules.form.ipBlockLabel',
    defaultMessage: 'IP Block'
  },
  CARDHOLDER_BLOCK: {
    id: 't.app.settings.processingRules.form.blockCardHolder',
    defaultMessage: 'Block Card Holder'
  },
  SETTING_AUTO_LOCKOUT_TIMES: {
    id: 't.app.settings.processingRules.form.autoLockoutLabel',
    defaultMessage: 'Setting Auto Lockout Times'
  },
  SETTING_DUPLICATE_LOCKOUT_TIMES: {
    id: 't.app.settings.processingRules.form.duplicateLockoutLabel',
    defaultMessage: 'Setting Duplicate Lockout Times'
  },
  ENABLED: {
    id: 't.app.settings.processingRules.form.statusEnabled',
    defaultMessage: 'Enabled'
  },
  DISABLED: {
    id: 't.app.settings.processingRules.form.statusDisabled',
    defaultMessage: 'Disabled'
  },
  CREDIT: {
    id: 't.app.settings.processingRules.form.cardType.credit',
    defaultMessage: 'Credit'
  },
  DEBIT: {
    id: 't.app.settings.processingRules.form.cardType.debit',
    defaultMessage: 'Debit'
  },
  PREPAID: {
    id: 't.app.settings.processingRules.form.cardType.prepaid',
    defaultMessage: 'Prepaid'
  },
  IP_TOOLTIP: {
    id: 't.app.settings.processingRules.form.ipAddressTooltip',
    defaultMessage:
      'If the IP address has the format X.X.X.X, a specific address can be blocked individually. If the number of most significant bits are specified after a slash e.g./30, a range of IP addresses can be blocked according to the CIDR notation.'
  }
}
export const messages = {
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  }
}